<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="p-g-12">
    <p-toolbar>
        <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
            <button routerLink="/requests-management" pButton type="button" [label]='setLabel("goBtnBackLabel")'
                icon="pi pi-arrow-left"></button>&nbsp;
            <!-- <button class="p-button p-widget p-state-default p-corner-all p-button-text-only printButton">
                <i class="fa fa-print printIcon" aria-hidden="true"></i> {{setLabel("printLabel")}}
            </button> -->
        </div>
    </p-toolbar>
</div>
<div id="invoice" style="display: none;">
    <div class="invoice-box" style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;">
        <div style="width: 57mm;max-width: 57mm;">
            <img [src]=" (company?.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                alt="Company Logo"
                style="display: block;margin-left: auto; margin-right: auto;width: 58%;margin-top: 3px; margin-bottom: 2px;">
            <div style="text-align: center;font-size: 11px;line-height: 14px; color: black;">{{selectedBranch?.address}}
            </div>
            <div style="text-align: center;font-size: 11px;line-height: 15px; color: black;"> {{selectedBranch?.phone}}
            </div>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">{{setLabel("invoiceNoLabel")}}</td>
                        <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">{{setLabel("createdDateLabel")}}
                        </td>
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center; padding: 0px;">{{fund.invoice}}</td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;"> {{fund.date | date:
                            'dd/MM/yyyy'}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
                <tbody>
                    <tr  *ngIf="branch.invoiceData.showAddedBy && branch.invoiceData.showAddedBy === true">
                        <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">
                            {{setLabel("addedLabel")}}</td>
                            <td style="font-size: 10px;text-align: center; padding: 0px;">{{user.name}}</td>

                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">
                            {{setLabel("dayPassLabel")}}
                        </td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;"> {{visitor.dayPass}}
                    </tr>

                </tbody>
            </table>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">
                <thead
                    style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
                    <tr style="background-color: black;color: white; border: 1px solid black;">
                        <th style="width: 40px;   word-break: break-word; font-size: 10px;" colspan="2">{{setLabel("nameLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("feesLabel")}}</th>
                        <th *ngIf="fund.discount" style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("discountLabel")}}</th>
                        <th *ngIf="fund.tax" style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("taxLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("payLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("statusLabel")}}</th>
                    </tr>
                </thead>
                <tbody>
                    <span>
                        <tr>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;" colspan="2">
                                {{visitor.name}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.fee}}</td>
                            <td *ngIf="fund.discount" style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.discount}}</td>
                            <td *ngIf="!hideTaxInfo" style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.tax}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.pay}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.status}}</td>
                        </tr>
                    </span>
                    <tr>
                        <td style="font-size: 10px; text-align: center;  font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;border-bottom: 1px solid;border-left: 1px solid;"
                            colspan="5">{{setLabel("totalLabel")}}</td>
                        <td style="font-size: 10px;text-align: start; border-right: 1px solid;
                      border-bottom: 1px solid;">{{fund.pay}}</td>
                    </tr>
                </tbody>
            </table>
            <div
                style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black;white-space: nowrap;">
                {{setLabel("softwareProvidedLabel")}}
            </div>
        </div>
    </div>
</div>
<div class="p-g-12 visitor-request-detail">

    <form class="form" #requestorForm="ngForm" (ngSubmit)="update(requestorForm)">
        <div class="p-g-12">
            <h3 class="title first">{{setLabel("visitorDetailsLabel")}}</h3>
        </div>
        <div class="input-detail-main">
            <div class="p-g-12 p-md-6">
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("requestIDLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-hashtag" aria-hidden="true"></i></span>
                        <input class="input" autocomplete="off" #requestId readonly name="requestId"
                            [(ngModel)]="requestor.requestId" />
                    </div>
                </div>
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("nameLabel")}} <span class="asterisk">*</span></h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                        <input class="input" autocomplete="off" required #name="ngModel" pattern="[A-Za-z ]+" [ngClass]="
                        name.invalid &&
                        (name.dirty || name.touched)
                            ? 'errorInput'
                            : ''
                    " type="text" pInputTextplaceholder="Name*" name="name" [(ngModel)]="requestor.name" />
                    </div>
                    <div *ngIf="
                    name.invalid &&
                    (name.dirty || name.touched)
                ">
                        <div *ngIf="name.errors.required" class="errorShow">
                          {{setLabel("nameRequiredErrorLabel")}}
                        </div>
                        <div *ngIf="name.errors.pattern" class="errorShow">
                            {{setLabel("charactersAllowedErrorLabel")}}
                        </div>
                    </div>
                </div>
                <div class="p-g-12">
                    <h3 class="first">
                        {{setLabel("mobileLabel")}} <span class="asterisk">*</span>
                    </h3>
                    <app-phone-input
                        [placeholder]='setLabel("mobile*PlaceholderLabel")'
                        [(phoneNumber)]="requestor.contactDetail.contact"
                        [initialCountry]="'PK'"
                        (validNumber)="formattedNumber = $event"
                        (formattedForSaving)="requestor.contactDetail.contact = $event"
                        style="max-width: 600px; margin: auto; align-items: center;">
                    </app-phone-input>
                </div>

                <div class="p-g-12">
                    <h3 class="first">{{setLabel("emailLabel")}} <span style="color: gray; font-size: .8em;">(Optional) </span></h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                        <input class="input" type="email" autocomplete="off"
                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" pInputText
                            [placeholder]='setLabel("emailPlaceholderLabel")' name="email" #email="ngModel" [(ngModel)]="requestor.email" [ngClass]="
                        email.invalid && (email.dirty || email.touched)
                            ? 'errorInput'
                            : ''
                    " />
                    </div>
                    <div *ngIf="email.invalid && (email.dirty || email.touched)">
                        <div *ngIf="email.errors.required" class="errorShow">
                           {{setLabel("emailRequiredErrorLabel")}}
                        </div>
                        <div *ngIf="email.errors.pattern" class="errorShow">
                            {{setLabel("emailCorrectlyErrorLabel")}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="request-type p-g-12">

                                    <div class="p-g-12">
                                        <h3 class="first">{{setLabel("requestTypeLabel")}}</h3>
                                        <div class="p-inputgroup align-items-center">
                                            <span class="p-inputgroup-addon"><i class="fa fa-list" aria-hidden="true"></i></span>
                                            {{ requestor.requestType }}
                                        </div>
                                    </div>

                                        <div class="p-g-12">
                                            <h3 class="first">{{setLabel("visitorTypeLabel")}}</h3>
                                            <p-dropdown [options]="visitorTypes" optionLabel="name"
                                                                            (onChange)="onSelect($event)"></p-dropdown>
                                        </div>
                                    <div class="p-g-12">
                                        <span>{{setLabel("requireTrainerLabel")}}</span>
                                        <p-checkbox [label]='setLabel("trainerLabel")' name="trainingBySomeoneElse" (onChange)="onCheckboxChange()"></p-checkbox>
                                    </div>


                                    <div class="p-g-12" *ngIf="trainingBySomeoneElse">
                                        <span class="p-g-4">{{setLabel("trainer:Label")}}</span>
                                        <p-dropdown class="p-g-8" [options]="allTrainers" [(ngModel)]="selectedTrainer" (onChange)="onConductedTrainerChange($event)" [placeholder]='setLabel("selectTrainerPlaceholderLabel")' name="trainerName" optionLabel="name">
                                        </p-dropdown>
                                    </div>

                                    <div class="p-g-12">
                                        <h3 class="first">{{setLabel("visitorFeeLabel")}} <span class="asterisk"> * </span></h3>
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                                            <input class="input" type="text" pInputText #visitorFee="ngModel" [placeholder]='setLabel("feePlaceholderLabel")'
                                                name="visitorFee" autocomplete="off" [(ngModel)]="requestor.visitorFee" />
                                        </div>
                                    </div>

                                    <div class="p-g-12">
                                        <h3 class="first">{{setLabel("visitorDiscountLabel")}} </h3>
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                                            <input class="input" type="text" pInputText #visitorFeeDiscount="ngModel" [placeholder]='setLabel("feePlaceholderLabel")'
                                                name="visitorFeeDiscount" autocomplete="off" [(ngModel)]="requestor.visitorFeeDiscount" (ngModelChange)="recalculateTax()" />
                                        </div>
                                    </div>
                            <div class="p-g-12" *ngIf="taxType != 'NO_TAX'" >
                                <h3 class="first">{{setLabel("taxLabel")}}</h3>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                                    <input type="number" [placeholder]='setLabel("taxPlaceholderLabel")' pInputText #visitingTax="ngModel"
                                        name="visitingTax" [(ngModel)]="visitorFeeTax" autocomplete="off" pattern="[0-9]+" id="visitingTax"
                                        disabled>
                                </div>
                                <span style="margin-left: 3em;font-style: italic; font-size: 12px; color: blue;"
                                    *ngIf="taxType == 'INCLUDING_TAX'">{{visitorFeeTax}} {{setLabel("taxIncludedFeeLabel")}} </span>
                            </div>
                                    <div class="p-g-12" *ngIf="taxType == 'NO_TAX' || taxType == 'INCLUDING_TAX'">
                                        <h3 class="first"> {{setLabel("totalFeesLabel")}}</h3>
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                                            <input readonly pInputText type="number" value="{{(requestor.visitorFee - requestor.visitorFeeDiscount)}}">
                                        </div>
                                    </div>
                            <div class="p-g-12" *ngIf="taxType == 'WITH_TAX'" >
                                <h3 class="first"> {{setLabel("totalFeesLabel")}}</h3>
                                <div class="p-inputgroup">
                                    <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                                    <input readonly pInputText type="number" value="{{((requestor.visitorFee - requestor.visitorFeeDiscount) + visitorFeeTax )}}">
                                </div>
                            </div>
                        <h3 class="first" >{{setLabel("modeOfPaymetLabel")}}</h3>
                        <div class="p-g-12">
                            <p-dropdown class="p-g-6" [options]="paymentOptions" (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                        </div>
                <div class="p-g-12">
                    <div class="p-g">
                        <h3 class="first">{{setLabel("genderLabel")}}</h3>
                        <div class="gender-option  p-g-12">
                            <div class="p-g-6">
                                <p-radioButton name="gender" value="M" [label]='setLabel("maleLabel")' [(ngModel)]="requestor.gender"
                                    inputId="opt1">
                                </p-radioButton>
                            </div>
                            <div class="p-g-6">
                                <p-radioButton name="gender" value="F" [label]='setLabel("femaleLabel")' [(ngModel)]="requestor.gender"
                                    inputId="opt2">
                                </p-radioButton>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-g-12">
                    <h3 class="first">{{setLabel("requestStatusLabel")}}</h3>
                    <div class="p-inputgroup align-items-center">
                        <span class="p-inputgroup-addon"><i class="fa fa-question-circle" aria-hidden="true"></i></span>
                        {{ requestor.requestStatus }}
                    </div>
                </div>
                <div class="btn-main">
                    <button pButton type="button"
                        class="p-button-primary submitButton p-widget p-state-default p-corner-all rejectButton"
                        (click)="rejectRequest()" *ngIf="requestor?.requestStatus === RequestStatus.Pending">
                        <span class="p-button-text p-c">
                            <i class="fa fa-times" aria-hidden="true"></i>
                            &nbsp;{{setLabel("rejectBtnLabel")}}
                        </span>
                    </button>
                    &nbsp;
                    <button class="p-button p-widget p-state-default p-corner-all p-button-text-only printButton"
                        (click)="update(requestorForm)">
                        <i class="fa fa-print updateIcon" type="submit" aria-hidden="true"></i>
                        {{setLabel("updateBtnLabel")}}
                    </button>
                    &nbsp;
                    <button pButton type="button"
                        class="p-button-success submitButton p-widget p-state-default p-corner-all approvalButton"
                        (click)="proceedForApproval(requestorForm)"
                        *ngIf="requestor?.requestStatus === RequestStatus.Pending">
                        <!-- [disabled]="!requestorForm.valid" -->
                        <span class="p-button-text p-c">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                            &nbsp;{{setLabel("approveBtnLabel")}}
                        </span>
                    </button>
                </div>
            </div>
        </div>

    </form>
</div>

<!-- ////////// For Print Registration Request Detail ////////// -->

<div id="requestDetailsForPrint" #requestDetailsForPrint style="display: none">
    <div class="invoice-box">
        <h1 style="text-align: center">{{setLabel("registrationRequestDetailsLabel")}}</h1>
        <table>
            <tbody>
                <td style="vertical-align: middle; padding: 0px">
                    <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%" />
                </td>
                <td>
                    <div style="width: 150px">{{ branch.name }}</div>
                    <div style="width: 150px">{{ branch.address }}</div>
                    <div>{{setLabel("phoneNo:Label")}} {{ branch.phone }}</div>
                    <div>{{setLabel("created:Label")}} {{ date | date : "dd/MM/yyyy" }}</div>
                </td>
            </tbody>
        </table>
        <br />
        <br />
        <div style="display: flex; justify-content: space-between">
            <div class="car-detail" style="
                    margin-bottom: 5rem;
                    flex-direction: column;
                    width: 200px;
                    height: 200px;
                ">
                <span style="
                        padding-bottom: 10px;
                        font-weight: 600;
                        display: flex;
                        justify-content: center;
                    ">{{setLabel("profileImageLabel")}}</span>

                <img width="100%" height="100%" [src]="
                        requestor.profile == 'assets/layout/images/avatarBoyImage.png' " />
            </div>
            <!-- <div class="car-detail" style="width: 250px; height: 200px">
                <span style="
                        padding-bottom: 10px;
                        font-weight: 600;
                        display: flex;
                        justify-content: center;
                    ">{{setLabel("cOVIDImageLabel")}}</span>
                <img width="100%" height="100%" [src]="
                        requestor.profile == null
                            ? 'assets/layout/images/avatarBoyImage.png'
                            : config.Server + config.covidImagePath +
                              requestor.registrationDetail.covidImageUrl
                    " />
            </div> -->
            <div class="car-detail" style="width: 250px; height: 200px">
                <span style="
                        padding-bottom: 10px;
                        font-weight: 600;
                        display: flex;
                        justify-content: center;
                    ">{{setLabel("cNICImageLabel")}}</span>
                <img width="100%" height="100%" [src]="
                        requestor.profile == null
                            ? 'assets/layout/images/avatarBoyImage.png'
                            : config.Server + config.cnicImagePath +
                              requestor.registrationDetail.CNICImageUrl
                    " />
            </div>
        </div>
        <table style="display: flex; justify-content: center">
            <tbody>
                <tr class="information">
                    <td style="
                            padding-bottom: 10px;
                            text-align-last: start !important;
                            font-weight: 600;
                        ">
                        {{setLabel("requestID:Label")}}
                    </td>
                    <td class="rqName" style="padding-bottom: 10px">
                        {{ requestor.requestId }}
                    </td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            font-weight: 600;
                            padding-left: 20px;
                        ">
                        {{setLabel("cNIC:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">
                        {{ requestor.registrationDetail.CNIC }}
                    </td>
                    <td></td>
                </tr>
                <tr class="information">
                    <td style="
                            padding-bottom: 10px;
                            text-align-last: start !important;
                            font-weight: 600;
                        ">
                        {{setLabel("name:Label")}}
                    </td>
                    <td class="rqName" style="padding-bottom: 10px">
                        {{ requestor.name }}
                    </td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            font-weight: 600;
                            padding-left: 20px;
                        ">
                        {{setLabel("gender:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">{{ requestor.gender }}</td>
                    <td></td>
                </tr>
                <tr class="information">
                    <td style="padding-bottom: 10px; font-weight: 600">
                        {{setLabel("email:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">{{ requestor.email }}</td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            padding-left: 20px;
                            font-weight: 600;
                        ">
                        {{setLabel("mobile:Label")}}
                    </td>
                    <td style="padding-bottom: 10px">
                        {{ requestor.contactDetail.contact }}
                    </td>
                </tr>
                <tr class="information">
                    <td style="padding-bottom: 10px; font-weight: 600">
                        {{setLabel("address:Label")}}
                    </td>
                    <td style="padding-bottom: 10px; text-align: left">
                        {{ requestor.contactDetail.address.street }},{{
                        requestor.contactDetail.address.city
                        }}
                    </td>
                    <td></td>
                    <td style="
                            padding-bottom: 10px;
                            padding-left: 20px;
                            font-weight: 600;
                        ">
                        {{setLabel("requestType:Label")}}
                    </td>
                    <td style="padding-bottom: 10px; text-align: left">
                        {{ requestor.requestType }}
                    </td>
                </tr>
            </tbody>
        </table>
        <br />
        <br />
        <table style="display: flex; justify-content: center">
            <tbody>
                <tr>
                    <td>
                        <div style="text-align: center" class="logoDiv">
                            {{setLabel("poweredByLabel")}} &nbsp;
                            <a href="http://tecfolk.com/" target="_blank">
                                <img style="width: 66px"
                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="" />
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>